<template>
  <div>
    <div class="row top">
      <div class="row">
        <div class="col-md-2">
          <back-button returnUrl="/adminTools"></back-button>
        </div>
      </div>

      <div class="row">
        <div class="col-md-11">
          <h4><u>Versions</u></h4>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-3">
        <DxLoadIndicator
          id="image-indicator"
          :height="40"
          :width="40"
          :visible="loadIndicatorVisible"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 grid-pad">
        <DxDataGrid
          :data-source="versions"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :column-auto-width="true"
          :show-borders="true"
          :show-row-lines="true"
          :row-alternation-enabled="true"
          :wordWrapEnabled="true"
          width="100%"
        >
          <DxPaging :page-size="20" :enabled="true" />
          <DxEditing :allow-updating="true" :use-icons="true" mode="cell" />
          <DxHeaderFilter :visible="true" />
          <DxFilterRow :visible="true" />
          <DxSearchPanel :visible="true" />

          <DxColumn
            caption="Code"
            :allow-editing="false"
            data-field="Code"
            data-type="string"
            :visible="true"
            width="200px"
            alignment="center"
            :allow-filtering="true"
          >
          </DxColumn>
          <DxColumn
            caption="Περιγραφή"
            :allow-editing="false"
            data-field="Description"
            data-type="string"
            :visible="true"
            width="300px"
            alignment="left"
            :allow-filtering="true"
          >
          </DxColumn>
        </DxDataGrid>
      </div>
    </div>
  </div>
</template>

<script>
import BackButton from "../../components/shared/backButton";
import mainService from "../../services/mainService";
import {
  DxDataGrid,
  DxColumn,
  DxHeaderFilter,
  DxPaging,
  DxFilterRow,
  DxSearchPanel,
  DxEditing,
} from "devextreme-vue/data-grid";
import DxDateBox from "devextreme-vue/date-box";
import { DxLoadIndicator } from "devextreme-vue/load-indicator";

export default {
  components: {
    BackButton,
    DxLoadIndicator,
    DxDataGrid,
    DxColumn,
    DxHeaderFilter,
    DxPaging,
    DxFilterRow,
    DxSearchPanel,
    DxEditing,
  },
  data() {
    return {
      loadIndicatorVisible: false,
      versions: [],
    };
  },
  created() {},
  computed: {
    isSuperAdmin() {
      return this.$store.getters.isSuperAdmin;
    },
  },
  methods: {},
  async mounted() {
    this.loadIndicatorVisible = true;
    const res = await mainService.get(`/Versions/GetVersions`);
    this.versions = res.data;
    this.loadIndicatorVisible = false;
  },
};
</script>

<style scoped>
</style>
